import _ from "lodash"
import { List } from "immutable"
import type { List as ListType } from "immutable"

import cuckoo from "common/services/cuckoo/cuckoo"
import mapperJourney from "common/services/journey/mapperJourney"
import { cuckooEvents } from "common/consts/enums"
import type Journey from "common/records/Journey"
import { getAirlines } from "common/services/staticData"

/*
 * @returns {OrderedMap<version, Journey>} - history versions with their respectable journey change
 */
export default function(input): ?ListType<Journey> {
  try {
    // NOTE!!!
    // This is a terrible idea and only here as a god damn hotfix
    // If I see anyone else doing this shit he's gonna have to explain himself
    // in front of every FE dev eye to eye as a shaming ritual
    const airlines = getAirlines(window.__INITIAL_STATE__)

    return _.reduce(
      input,
      (acc, journey) => acc.push(mapperJourney(journey, "", false, airlines)),
      List(),
    )
  } catch (err) {
    cuckoo.error(cuckooEvents.INTERNAL_MAPPER_FLIGHTS_HISTORY_UNSUPPORTED_FORMAT, { input, err })
    return null
  }
}
